import React from 'react';

// Visible TESTING indicator. Renders ONLY when the app is pointed at the
// testing backend (REACT_APP_API_URL contains 'voice-testing'), so a prod
// build never shows it. Fixed, non-interactive, high-contrast.
export default function TestingBadge() {
  const api = (process.env.REACT_APP_API_URL || '');
  const isTesting = /voice-testing/i.test(api);
  if (!isTesting) return null;
  return (
    <div
      aria-label="Testing environment"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        pointerEvents: 'none',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          margin: '6px auto',
          padding: '2px 12px',
          borderRadius: '9999px',
          background: '#b91c1c',
          color: '#fff',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.08em',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        }}
      >
        TESTING
      </div>
    </div>
  );
}
